/** Regex tolerante usada na busca dos Searchers do painel (letras em ordem, com lacunas). */
export default function searchPattern(search: string) {
  return new RegExp(search.split('').join('.*'), 'i');
}
